import { render } from "./divider-line.vue?vue&type=template&id=afee48aa"
import script from "./divider-line.vue?vue&type=script&lang=js"
export * from "./divider-line.vue?vue&type=script&lang=js"

import "./divider-line.vue?vue&type=style&index=0&id=afee48aa&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__